module.exports = __webpack_public_path__ + "static/map_vertical_usa-3e2558e9c80c3588a2a6f77cdd14de2a.png";